



































































































































































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import AppHeader from 'frontend/components/AppHeader.vue';
import LandingHeaderV2 from 'frontend/views/landing/LandingHeaderV2.vue';
import LandingFooter from 'frontend/views/landing/LandingFooter.vue';
import { MobileGetter } from 'frontend/types';

@Component({
  metaInfo() {
    return {
      title: 'Careers',
    };
  },
  components: {
    AppHeader,
    LandingHeaderV2,
    LandingFooter,
  },
  computed: {
    ...mapGetters('globals', ['isAuthenticated']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapState('careers', ['categories']),
  },
})
export default class Careers extends Vue {
  private activeSection: string | null = null;
  private currentGalleryScroll: number = 0;
  private galleryScrollRate: number = 100 / 3;
  private isMobile!: MobileGetter;

  private scrollToOpenRoles(): void {
    (this.$refs.openRolesAnchor as Element).scrollIntoView({ behavior: 'smooth' });
  }

  private scrollGalleryLeft(): void {
    if (this.currentGalleryScroll + this.galleryScrollRate <= 0) {
      this.currentGalleryScroll += this.galleryScrollRate;
    }
  }

  private scrollGalleryRight(): void {
    if (this.currentGalleryScroll - this.galleryScrollRate > -100) {
      this.currentGalleryScroll -= this.galleryScrollRate;
    }
  }

  private toggleTeamSection(name: string): void {
    if (this.activeSection === name) {
      this.activeSection = null;
    } else {
      this.activeSection = name;
    }
  }

  private isTeamSectionOpen(name: string): boolean {
    return !this.isMobile(this.$mq) || this.activeSection === name;
  }
}
